const TIKTOK = "https://www.tiktok.com/@photobomb.online";
const INSTAGRAM = "https://www.instagram.com/photobombonline/";

function TikTokIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
    </svg>
  );
}

function InstagramIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.2722.273 2.69 2.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  );
}

export function FooterSocialOrbs({ className = "" }: { className?: string }) {
  return (
    <div
      className={`landing-sans-copy flex flex-col items-center gap-2 sm:flex-row sm:items-center ${className}`}
    >
      <span className="text-sm font-medium text-white/70">Follow Photobomb</span>
      <div className="flex items-center gap-1.5 py-1">
        <a
          href={TIKTOK}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Photobomb on TikTok"
          className="footer-glass-hitbox landing-footer-ai-bubble-hitbox grid h-7 w-7 shrink-0 place-items-center overflow-visible rounded-full"
        >
          <span
            className="landing-glass-sphere landing-footer-ai-bubble grid h-full w-full place-items-center rounded-full"
            style={{ animationDelay: "0s" }}
          >
            <TikTokIcon className="block h-3.5 w-3.5 shrink-0" />
          </span>
        </a>
        <a
          href={INSTAGRAM}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Photobomb on Instagram"
          className="footer-glass-hitbox landing-footer-ai-bubble-hitbox grid h-7 w-7 shrink-0 place-items-center overflow-visible rounded-full"
        >
          <span
            className="landing-glass-sphere landing-footer-ai-bubble grid h-full w-full place-items-center rounded-full"
            style={{ animationDelay: "0.55s" }}
          >
            <InstagramIcon className="block h-3.5 w-3.5 shrink-0" />
          </span>
        </a>
      </div>
    </div>
  );
}
